"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as l } from "react";
import r from "../components/Icon/SvgIcon.js";
const i = (t) => /* @__PURE__ */ o(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...t,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        d: "m7.387 20.717 4.617-3.392 4.608 3.392c.604.435 1.128.541 1.554.222.417-.32.506-.844.266-1.545l-1.82-5.416 4.653-3.339c.603-.426.852-.906.683-1.403s-.639-.746-1.385-.737l-5.7.045-1.74-5.452C12.892 2.382 12.528 2 12.004 2c-.533 0-.897.382-1.128 1.092L9.145 8.544l-5.71-.045c-.745-.009-1.216.24-1.384.728-.169.506.089.986.683 1.412l4.653 3.339-1.82 5.416c-.24.701-.151 1.225.266 1.545.426.32.95.213 1.554-.222"
      }
    )
  }
), n = l(i);
export {
  n as Military,
  n as default
};
